import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarDataRefreshService {
  private refreshDataSubject = new Subject<{
    shiftId?: number;
    eventId?: number;
    refreshType: 'shift_updated' | 'shift_deleted' | 'guard_booked' | 'guard_cancelled' | 'description_updated' | 'time_updated' | 'guard_count_updated';
    data?: any;
  }>();

  // Observable that components can subscribe to
  refreshData$ = this.refreshDataSubject.asObservable();

  /**
   * Trigger a data refresh for the calendar
   * @param refreshType - Type of refresh needed
   * @param shiftId - Optional shift ID that was updated
   * @param eventId - Optional event ID that was updated
   * @param data - Optional additional data
   */
  triggerRefresh(refreshType: 'shift_updated' | 'shift_deleted' | 'guard_booked' | 'guard_cancelled' | 'description_updated' | 'time_updated' | 'guard_count_updated', shiftId?: number, eventId?: number, data?: any) {
    this.refreshDataSubject.next({
      refreshType,
      shiftId,
      eventId,
      data
    });
  }

  /**
   * Trigger a general calendar refresh
   */
  refreshCalendar() {
    this.refreshDataSubject.next({
      refreshType: 'shift_updated'
    });
  }
}
